import { Routes } from "@angular/router";
import { authGuard } from "@shared/guard/auth.guard";
import { ConfirmationGuard } from "@shared/guard/confirmation.guard";
import { firstTimeLoginGuard } from "@shared/guard/first-time-login.guard";
import { notFoundGuard } from "@shared/guard/not-found.guard";
import { passwordExpiredGuard } from "@shared/guard/password-expired.guard";

import { FirstTimeLoginComponent } from "./views/auth/first-time-login/first-time-login.component";
import { LoginComponent } from "./views/auth/login/login.component";
import { PasswordExpiredComponent } from "./views/auth/password-expired/password-expired.component";
import { ResetPasswordComponent } from "./views/auth/reset-password/reset-password.component";
import { SecretAnswerComponent } from "./views/auth/secret-answer/secret-answer.component";
import { NotFoundComponent } from "./views/not-found/not-found.component";

export const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  {
    path: "login",
    component: LoginComponent,
    // resolve: { user: LoginResolverService },
  },
  {
    path: "secret-answer",
    component: SecretAnswerComponent,
    canDeactivate: [ConfirmationGuard],
  },
  {
    path: "first-time-login",
    component: FirstTimeLoginComponent,
    canActivate: [firstTimeLoginGuard],
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent,
    canDeactivate: [ConfirmationGuard],
  },
  {
    path: "password-expired",
    component: PasswordExpiredComponent,
    canActivate: [passwordExpiredGuard],
    canDeactivate: [ConfirmationGuard],
  },
  {
    path: "summary",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./views/dashboard/dashboard.module").then(
        (m) => m.DashboardModule,
      ),
  },
  { path: "404", component: NotFoundComponent, canActivate: [notFoundGuard] },
  { path: "**", redirectTo: "404" },
];
